import { render } from "./SectionsPageView.vue?vue&type=template&id=3688f4a2&scoped=true"
import script from "./SectionsPageView.vue?vue&type=script&lang=js"
export * from "./SectionsPageView.vue?vue&type=script&lang=js"

import "./SectionsPageView.vue?vue&type=style&index=0&id=3688f4a2&lang=scss"
import "./SectionsPageView.vue?vue&type=style&index=1&id=3688f4a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3688f4a2"]])

export default __exports__